"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isString = void 0;
const isString = (maybeString) => typeof maybeString === 'string';
exports.isString = isString;
